var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show_this==true)?_c('span',{staticClass:"ml-1",attrs:{"variant":"advance"}},[_c('b-badge',{attrs:{"varient":"advance"}},[_vm._v(" M ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }